var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpermanentLoss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_5151)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_829_5151)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_829_5151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 191C199.454 191 259 166.226 259 135.666C259 105.106 199.454 80.3327 126 80.3327C52.5461 80.3327 -7 105.106 -7 135.666C-7 166.226 52.5461 191 126 191Z",
    fill: "url(#paint0_radial_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1006 89.0305L100.05 74.0171V81.5275L74.1006 96.5335V89.0305Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1221 81.5275L87.0717 66.5141L100.05 74.0171L74.1006 89.0305L61.1221 81.5275Z",
    fill: "url(#paint1_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1221 81.5275L74.1006 89.0305V96.5335L61.1221 89.0305V81.5275Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0723 89.0231L113.029 74.0097V81.5127L87.0723 96.5261V89.0231Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1006 81.5127L100.05 66.5067L113.029 74.0097L87.0717 89.0231L74.1006 81.5127Z",
    fill: "url(#paint2_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1006 81.5127L87.0717 89.0231V96.5261L74.1006 89.0231V81.5127Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.949 149.069L177.906 134.063V141.566L151.949 156.572V149.069Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.979 141.566L164.928 126.553L177.907 134.063L151.95 149.069L138.979 141.566Z",
    fill: "url(#paint3_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.979 141.566L151.95 149.069V156.572L138.979 149.069V141.566Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 149.069L190.877 134.063V141.566L164.928 156.572V149.069Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.949 141.566L177.906 126.553L190.877 134.063L164.928 149.069L151.949 141.566Z",
    fill: "url(#paint4_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.949 141.566L164.928 149.069V156.572L151.949 149.069V141.566Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.906 149.069L203.856 134.063V141.566L177.906 156.572V149.069Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 141.566L190.877 126.553L203.856 134.063L177.906 149.069L164.928 141.566Z",
    fill: "url(#paint5_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 141.566L177.906 149.069V156.572L164.928 149.069V141.566Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.979 134.063L164.928 119.05V126.553L138.979 141.566V134.063Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 126.553L151.95 111.547L164.928 119.05L138.979 134.063L126 126.553Z",
    fill: "url(#paint6_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 126.553L138.979 134.063V141.566L126 134.063V126.553Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 119.05L151.95 104.037V111.547L126 126.553V119.05Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.029 111.547L138.979 96.5336L151.95 104.037L126 119.05L113.029 111.547Z",
    fill: "url(#paint7_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.029 111.547L126 119.05V126.553L113.029 119.05V111.547Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.029 104.037L138.979 89.0305V96.5335L113.029 111.547V104.037Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 96.5335L126 81.5275L138.979 89.0305L113.029 104.037L100.051 96.5335Z",
    fill: "url(#paint8_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 96.5336L113.029 104.037V111.547L100.051 104.037V96.5336Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.051 89.0305L126 74.0171V81.5275L100.051 96.5335V89.0305Z",
    fill: "#570EE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0723 81.5275L113.029 66.5141L126 74.0171L100.051 89.0305L87.0723 81.5275Z",
    fill: "url(#paint9_linear_829_5151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0723 81.5275L100.051 89.0305V96.5335L87.0723 89.0305V81.5275Z",
    fill: "#8060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.007 67.2266L110.14 65.4232L110.37 65.3044L107.244 67.1301L107.007 67.2266Z",
    fill: "#390997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.244 67.1301L110.37 65.3044C110.558 65.2154 110.754 65.1457 110.955 65.0966L107.822 66.9223C107.622 66.9702 107.429 67.0399 107.244 67.1301",
    fill: "#3B0A9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.821 66.9223L110.955 65.0966C111.229 65.0304 111.51 64.998 111.792 65.0002L108.658 66.8258C108.376 66.8236 108.095 66.856 107.821 66.9223",
    fill: "#3D0AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.659 66.8258L111.793 65.0002C112.792 65.0386 113.764 65.3352 114.615 65.8611L111.482 67.6867C110.632 67.1574 109.659 66.8606 108.659 66.8258",
    fill: "#3F0AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.48 67.6867L114.614 65.861L114.777 65.9649L111.643 67.7832L111.48 67.6867",
    fill: "#3F0AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.644 67.7831L114.777 65.9649C115.121 66.1712 115.451 66.4019 115.762 66.6551L112.629 68.4733C112.314 68.225 111.985 67.9946 111.644 67.7831",
    fill: "#3D0AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.629 68.4733L115.762 66.6551C116.007 66.848 116.251 67.0558 116.503 67.2711L113.37 69.0967C113.134 68.8763 112.886 68.6682 112.629 68.4733",
    fill: "#3B0A9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.348 69.0967L116.481 67.2711C116.689 67.464 116.896 67.6718 117.089 67.8796L113.955 69.7053C113.762 69.4975 113.555 69.2897 113.348 69.0967Z",
    fill: "#390997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.954 69.7053L117.088 67.8796C117.273 68.08 117.458 68.2878 117.629 68.503L114.488 70.3287C114.31 70.1135 114.125 69.9057 113.939 69.7053",
    fill: "#380993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.488 70.3287L117.614 68.5031C117.792 68.7109 117.963 68.9261 118.126 69.1487L115.007 70.9744C114.844 70.7517 114.673 70.5365 114.503 70.3287",
    fill: "#36098E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.007 70.9743L118.14 69.1487C118.303 69.3787 118.466 69.6088 118.614 69.8463L115.481 71.6794C115.333 71.4419 115.17 71.2118 115.007 70.9818",
    fill: "#340889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 71.6794L118.614 69.8537C118.777 70.0986 118.933 70.3584 119.081 70.5958L115.969 72.4215C115.821 72.1593 115.666 71.9119 115.503 71.6794",
    fill: "#320885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.969 72.4215L119.103 70.6033C119.266 70.8927 119.422 71.1821 119.57 71.479L116.414 73.3121C116.273 73.0152 116.118 72.7184 115.947 72.4289",
    fill: "#310880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.414 73.3121L119.548 71.4865C119.725 71.8501 119.888 72.2286 120.036 72.5922L116.903 74.4179C116.755 74.0468 116.592 73.6758 116.414 73.3121",
    fill: "#2F087C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.903 74.4179L120.036 72.5922C120.567 73.9093 120.851 75.3131 120.873 76.7333C120.873 78.7149 120.133 80.1101 119.044 80.7706L115.91 82.5962C117.036 81.9357 117.74 80.5405 117.747 78.5516C117.723 77.1333 117.436 75.7318 116.903 74.4179",
    fill: "#2D0777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.481 67.6867C114.948 69.6979 117.755 74.5589 117.748 78.5516C117.74 82.5443 114.911 84.1621 111.436 82.1584C107.962 80.1546 105.169 75.2787 105.177 71.286C105.184 67.2934 108.007 65.6829 111.481 67.6867Z",
    fill: "#480CBE"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_829_5151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.04 135.699) scale(132.809 55.3135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8060EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8060EA",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_829_5151",
    x1: 61.1221,
    y1: 77.7723,
    x2: 100.05,
    y2: 77.7723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_829_5151",
    x1: 74.1006,
    y1: 77.7649,
    x2: 113.029,
    y2: 77.7649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_829_5151",
    x1: 138.979,
    y1: 137.811,
    x2: 177.907,
    y2: 137.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_829_5151",
    x1: 151.949,
    y1: 137.811,
    x2: 190.877,
    y2: 137.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_829_5151",
    x1: 164.928,
    y1: 137.811,
    x2: 203.856,
    y2: 137.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_829_5151",
    x1: 126,
    y1: 122.805,
    x2: 164.928,
    y2: 122.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_829_5151",
    x1: 113.029,
    y1: 107.792,
    x2: 151.95,
    y2: 107.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_829_5151",
    x1: 100.051,
    y1: 92.7783,
    x2: 138.979,
    y2: 92.7783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_829_5151",
    x1: 87.0723,
    y1: 77.7723,
    x2: 126,
    y2: 77.7723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9FC0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_5151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    fill: "white",
    transform: "translate(24 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_829_5151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251,
    height: 172,
    fill: "white",
    transform: "translate(2.5 42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_829_5151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 126,
    fill: "white",
    transform: "translate(-7 65)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpermanentLoss);
export default __webpack_public_path__ + "static/media/impermanent_loss.f03430f71161cedee245b4c83f57bc34.svg";
export { ForwardRef as ReactComponent };